import { checkTokenExpired, hubFetchJson } from "utils/apiUtils";
import { END_POINT } from "constants/apiConstant";
const {
  BOM_FILE_UPLOAD,
  BOM_COLUMN_MAPPING,
  BOM_COLUMN_KEY_SAVE,
  BOM_STATUS,
  BOM_ITEM_REFRESH,
  BOM_ITEMS_BATCH_REFRESH,
  BOM_AI_TOKEN_REFRESH,
  BOM_AI_SEARCH,
  SAVE_BOM_DISTRIBUTORS,
} = END_POINT;

export const saveBomDistributorsAPI = async (payload) => {
  return await hubFetchJson(SAVE_BOM_DISTRIBUTORS, {
    method: "POST",
    headers: {
      "content-type": "application/json",
    },
    body: JSON.stringify(payload),
  })
    .then((response) => {
      if (response.status)
        return { status: true, data: response.data, message: response.message };
      return { status: false, message: response.message };
    })
    .catch(function (error) {
      return {
        status: false,
        message: "Something went wrong, please try again later.",
        error,
      };
    });
};

export const getBomItemRefreshAPI = async (id) => {
  return await hubFetchJson(BOM_ITEM_REFRESH, {
    method: "POST",
    headers: {
      "content-type": "application/json",
    },
    body: JSON.stringify({ id }),
  })
    .then((data) => {
      if (data.status)
        return {
          status: true,
          data: data.data,
          message: data.message,
        };
      else {
        return { status: false, message: data.message };
      }
    })
    .catch(function (error) {
      return {
        status: false,
        message: "Something went wrong, please try again later.",
        error,
      };
    });
};

export const getBomItemsBatchRefreshAPI = async (payload) => {
  return await hubFetchJson(BOM_ITEMS_BATCH_REFRESH, {
    method: "POST",
    headers: {
      "content-type": "application/json",
    },
    body: JSON.stringify(payload),
  })
    .then((response) => {
      console.log("BomBatchItemRefresh -Api-response===>", response);
      if (response.status)
        return {
          status: true,
          data: response.data,
          message: response.message,
        };
      else {
        return { status: false, message: response.message };
      }
    })
    .catch(function (error) {
      return {
        status: false,
        message: "Something went wrong, please try again later.",
        error,
      };
    });
};

export const uploadBomFileAPI = async (file, extraFields = null) => {
  const formData = new FormData();
  formData.append("file", file[0]);
  // e.g. { hub_bom_id, hub_project_id } when the upload is an import of a Hub
  // board — the backend stores them so the Hub's bom-status fan-out can find
  // this upload again.
  if (extraFields) {
    Object.entries(extraFields).forEach(([k, v]) => {
      if (v !== null && v !== undefined && v !== "") formData.append(k, v);
    });
  }

  return await hubFetchJson(BOM_FILE_UPLOAD, {
    method: "POST",
    body: formData,
  })
    .then((response) => {
      // console.log("BOM-File-Upload-Api-response", response);
      if (response.status === true)
        return {
          data: response.bom,
          status: response.status,
          message: response.message || "BOM file uploaded successfully!",
        };
      else return { status: false, message: response.message };
    })
    .catch(function (error) {
      return { status: false, message: "Something went wrong from api", error };
    });
};

export const getColumnMappingAPI = async (id) => {
  return await hubFetchJson(BOM_COLUMN_MAPPING + id, {
    method: "GET",
    headers: {
      "content-type": "application/json",
    },
  })
    .then((response) => {
      // console.log("Column-Mapping-Api-response", response);
      if (response.status === true)
        return {
          data: response.data,
          status: response.status,
          message: response.message || "Column mapping fetched successfully!",
        };
      else return { status: false, message: response.message };
    })
    .catch(function (error) {
      return { status: false, message: "Something went wrong from api", error };
    });
};

export const bomColumnKeySaveAPI = async (payload) => {
  return await hubFetchJson(BOM_COLUMN_KEY_SAVE, {
    method: "POST",
    headers: {
      "content-type": "application/json",
    },
    body: JSON.stringify(payload),
  })
    .then((data) => {
      console.log("BOM-Column-Key-Save-Api-response", data);
      if (data.status) return { status: true, data: data.data, message: data.message };
      else {
        return { status: false, message: data.message };
      }
    })
    .catch(function (error) {
      return {
        status: false,
        message: "Something went wrong, please try again later.",
        error,
      };
    });
};

export const getBomStatusAPI = async (id) => {
  return await hubFetchJson(BOM_STATUS, {
    method: "POST",
    headers: {
      "content-type": "application/json",
    },
    body: JSON.stringify({ uniqueId: id }),
  })
    .then((response) => {
      console.log("BOM-Status-Api", response);
      checkTokenExpired(response);
      if (response.status)
        return {
          status: true,
          data: {
            bom: response.bom,
            bom_items: response.bom_items,
            distributorMin: response.DistributorMinimumPrice,
          },
          message: response.message,
        };
      else {
        return { status: false, message: response.message };
      }
    })
    .catch(function (error) {
      return {
        status: false,
        message: "Something went wrong, please try again later.",
        error,
      };
    });
};

export const refreshBomAiTokenAPI = async () => {
  return await hubFetchJson(BOM_AI_TOKEN_REFRESH, {
    method: "POST",
    headers: {
      "content-type": "application/json",
    },
  })
    .then((response) => {
      console.log("BOM-Ai-Token-Refresh-Api", response);
      if (response.status)
        return {
          status: true,
          data: response.data,
          message: response.message,
        };
      else {
        return { status: false, message: response.message };
      }
    })
    .catch(function (error) {
      return {
        status: false,
        message: "Something went wrong, please try again later.",
        error,
      };
    });
};

export const getBomAiSearchAPI = async (keyword) => {
  return await hubFetchJson(BOM_AI_SEARCH, {
    method: "POST",
    headers: {
      "content-type": "application/json",
    },
    body: JSON.stringify({ keyword }),
  })
    .then((response) => {
      console.log("getBomAiSearchAPI", response);
      if (response.status)
        return {
          status: true,
          data: response.data,
          message: response.message || "Search completed successfully",
        };
      else {
        return { status: false, message: "Please refresh token and try again" };
      }
    })
    .catch(function (error) {
      return {
        status: false,
        message: "Something went wrong, please try again later.",
        error,
      };
    });
};

export const getUploadedBomListApi = async () => {
  return await hubFetchJson(END_POINT.GET_UPLOADED_BOM_LIST, {
    method: "GET",
    headers: {
      "content-type": "application/json",
    },
  })
    .then((response) => {
      // console.log("getUploadedBomListAPI", response);
      if (response.status)
        return {
          status: true,
          data: response.data,
          message: response.message || "Uploaded BOM list fetched successfully",
        };
      else {
        return { status: false, message: "Please refresh token and try again" };
      }
    })
    .catch(function (error) {
      return {
        status: false,
        message: "Something went wrong, please try again later.",
        error,
      };
    });
};
